import http from "../http-common";

export const listSupporters = async (includeInactive = false) => {
  const url = includeInactive ? "/supporters?includeInactive=true" : "/supporters";
  const response = await http.get(url);
  return response.data;
};

export const createSupporter = async (supporter) => {
  const response = await http.post("/supporters", supporter);
  return response.data;
};

export const updateSupporter = async (id, supporter) => {
  const response = await http.put(`/supporters/${id}`, supporter);
  return response.data;
};

export const deleteSupporter = async (id) => {
  const response = await http.delete(`/supporters/${id}`);
  return response.data;
};
